export const clientUrl = "https://ninca90.com";

export const serverBaseURL = 'https://us-central1-ninca90-c16ee.cloudfunctions.net/app';